import * as React from "react"
import * as Yup from "yup"
import Form, { FormElement } from "@modules/form/components/Form"
import { MdArrowForward } from "react-icons/md"
import {
  Button,
  Notification,
  Text,
  StyledModalActions,
  InputConnectedField,
} from "gatsby-interface"
import {
  vercelIntegrationConfig as text,
  ui as uiText,
} from "@modules/locales/default.json"
import { useCreateVercelIntegration } from "../hooks/useCreateVercelIntegration"
import { FormattedMessage } from "@modules/locales"
import { VercelTeamField } from "../components/VercelTeamField"
import { normalizeVercelTeamId } from "../utils"

const validationSchema = Yup.object().shape({
  vercelTeam: Yup.string(),
  projectName: Yup.string()
    .required(uiText.messages.validationIsRequired)
    .matches(/^[a-zA-Z0-9-]+$/, {
      message: text.messages.projectNameValidateFormat,
      excludeEmptyString: true,
    }),
})

export function NewIntegration({
  onClose,
  onValidate,
  siteId,
  onSwitchToExisting,
}) {
  const [createVercelIntegration, { loading }] = useCreateVercelIntegration(
    onValidate
  )

  return (
    <Form
      initialValues={{
        projectName: "",
        vercelTeam: "",
      }}
      validationSchema={validationSchema}
      onSubmit={values =>
        createVercelIntegration(
          values.projectName,
          siteId,
          normalizeVercelTeamId(values.vercelTeam)
        )
      }
    >
      {() => {
        return (
          <FormElement applySpacing noValidate>
            <Text css={{ margin: 0 }}>{text.headers.connectToNew}</Text>

            <Notification
              variant="SECONDARY"
              tone="BRAND"
              content={
                <div>
                  <FormattedMessage
                    message={text.messages.connectToExistingSiteCallout}
                    tags={{
                      button: function(content) {
                        return (
                          <Button
                            onClick={onSwitchToExisting}
                            variant="GHOST"
                            size="M"
                            css={{ padding: 0, fontSize: `inherit` }}
                            aria-label={text.actions.switchToExistingSite}
                          >
                            {content}
                          </Button>
                        )
                      },
                    }}
                  />
                </div>
              }
            />
            <VercelTeamField
              siteId={siteId}
              name="vercelTeam"
              label={text.labels.vercelProjectTeam}
              required
            />

            <InputConnectedField
              name="projectName"
              label={text.labels.vercelProjectName}
              required
            />

            <StyledModalActions>
              <Button variant="SECONDARY" type={`reset`} onClick={onClose}>
                {uiText.actions.cancel}
              </Button>

              <Button
                type="submit"
                loading={loading}
                rightIcon={<MdArrowForward />}
              >
                {text.actions.create}
              </Button>
            </StyledModalActions>
          </FormElement>
        )
      }}
    </Form>
  )
}
